<template>
  <div>
    <!-- Semi-transparent overlay when menus are open -->
    <div class="menu-overlay" :class="{ 'is-visible': isAnyMenuOpen }"></div>

    <!-- Main app bar -->
    <v-app-bar
      :sticky="false"
      :elevation="0"
      v-if="!display.mobile.value"
      color="px-11"
      
      :class="[
        'app-bar-with-border',
        { 'app-bar': isAnyMenuOpen },
        { 'no-bg-on-menu': isAnyMenuOpen },
      ]"
    >
    <div class="bar-inner bar-main">
      <!-- Clickable Logo -->
      <v-img
        :src="require('@/assets/suuq.logo.svg')"
        alt="SUUQ Logo"
        class="ml-2"
        @click="logoRoute"
        cover
        max-width="100"
        style="cursor: pointer"
      />

    

      <!-- Navigation ecosystem icons -->
      <div class="ecosystem flex">
        <div
          v-for="item in ecosystem"
          :key="item.text"
          class="mx-5 text--darken-0"
          style="opacity: 0.7"
        >
          <!-- Searches dropdown -->
          <template v-if="item.search && loggedInUser && !isMySearchesRoute">
            <searches-dropdown :listings="displayListings">
              <div
                class="d-flex flex-column align-center"
                style="cursor: pointer"
              >
                <v-icon size="x-small">
                  {{ item.icon }}
                </v-icon>
                <span class="text-caption font-medium">{{ item.text }}</span>
              </div>
            </searches-dropdown>
          </template>

          <!-- Notifications dropdown -->
          <template v-else-if="item.notify && loggedInUser">
            <notifications-dropdown>
              <div
                class="d-flex flex-column align-center"
                style="cursor: pointer"
              >
                <span class="text-caption font-medium">{{ item.text }}</span>
              </div>
            </notifications-dropdown>
          </template>

          <!-- Standard navigation items -->
          <template v-else>
            <v-btn density="compact" stacked @click="routeTo(item.route)">
              <!-- Chats with badge if unread messages -->
              <template v-if="item.chaty && loggedInUser">
                <v-badge
                  v-if="unreadMessageCount > 0"
                  
                  :content="unreadMessageCount"
                >
                  <v-icon size="x-small">{{ item.icon }}</v-icon>
                </v-badge>
                <v-icon v-else size="x-small">
                  {{ item.icon }}
                </v-icon>
              </template>

              <!-- Regular icon for other items -->
              <template v-else>
                <v-icon size="x-small">{{ item.icon }}</v-icon>
              </template>

              <span class="text-caption font-medium">{{ item.text }}</span>
            </v-btn>
          </template>
        </div>
      </div>

      <!-- Login/Account section -->
      <div v-if="display.mdAndUp.value">
        <!-- Login button for guests -->
        <div v-if="!loggedInUser">
          <v-btn
            variant="text"
            class="text-caption font-medium mr-10"
            @click="loginOrSignup"
          >
            Log in or sign up
          </v-btn>

          <!-- Login dialog -->
          <v-dialog v-model="showLoginDialog" width="600">
            <v-card max-width="900">
              <auth-component />
            </v-card>
          </v-dialog>
        </div>

        <!-- User profile menu for logged in users -->
        <div v-else>
          <v-menu open-on-hover @update:model-value="handleMenuVisibility">
            <template v-slot:activator="{ props }">
              <v-avatar
                v-bind="props"
                size="small"
                class="mr-8 mt-1 text-caption"
                style="background-color: darkgoldenrod !important; color: white"
              >
                {{ getInitials(loggedInUser.fullName) }}
              </v-avatar>
              <span
                v-if="loggedInUser"
                class="text-caption font-semibold ml-n5 pt-2 mr-2"
              >
                {{ loggedInUser.fullName }}
              </span>
            </template>

            <v-list class="modal-menu">
              <v-list-item
                v-for="(list, i) in dropDownItems"
                :key="i"
                class="my-n1"
                @click="toggle(list)"
              >
                <v-list-item-title class="text-caption font-medium">
                  {{ list.name }}
                  <!-- Show My Ads count -->
                  <span
                    v-if="list.slug === 'myAds' && myAdsCount > 0"
                    class="ml-1 font-semibold"
                  >
                    ({{ myAdsCount }})
                  </span>
                </v-list-item-title>
                <v-divider
                  style="width: 100% !important"
                  class="my-2"
                ></v-divider>
              </v-list-item>

              <!-- Logout option -->
              <v-list-item @click="handleLogout">
                <v-list-item-title>
                  <div class="text-caption font-medium">
                    <v-icon size="small" color="blue" icon="mdi-logout-variant">
                    </v-icon>
                    Logout
                  </div>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <!-- Post Ad button -->
      <v-btn
        @click="placeAd"
        style="background-color: darkgoldenrod !important"
        class="error text-caption font-medium mr-16"
        variant="flat"
      >
      <span class="text-white">Place Your Ad</span>
    
      </v-btn>
      </div>
    </v-app-bar>

    <!-- Category navigation bar -->

    <div>
      <!-- Category navigation bar -->
      <div>
        <v-app-bar
          :sticky="false"
          :elevation="0"
          :class="['app-bar-with-border', { 'no-bg-on-menu': isAnyMenuOpen }]"
          density="compact"
          v-if="!display.mobile.value"
        >
           <div class="bar-inner bar-cats">
    <div class="categories-row">
          <div
            v-for="(category, index) in categories"
            :key="index"
            class="text-center ml-9 mx-1 category-header"
          >
            <!-- Category heading -->
            <div
              class="text-caption font-bold badge-hoover"
              variant="text"
              @click="handleCategoryClick(category)"
            >
              {{ category.name }}
              <!-- "NEW" badge for select categories -->
              <v-chip
                v-if="
                  category.id === 1 ||
                  category.id === 2 ||
                  category.id === 3 ||
                  category.id === 4
                "
                size="x-small"
                style="background-color: darkgoldenrod; color: white"
                class="category-badge"
              >
                NEW
              </v-chip>

              <!-- Two-column dropdown menu -->
              <v-menu
                open-on-hover
                activator="parent"
                :close-delay="200"
                class="modal-menu-wrapper"
                @update:model-value="handleMenuVisibility"
              >
                <v-card
                  min-width="500"
                  max-height="400"
                  class="modal-menu-card"
                >
                  <!-- Header with "View All" option -->
                  <v-card-title class="pa-2 category-menu-header">
                    <v-spacer></v-spacer>
                    <v-btn
                      variant="text"
                      size="small"
                      @click="handleCategoryClick(category)"
                      class="view-all-btn"
                    >
                      <span class="text-caption font-medium">View All →</span>
                    </v-btn>
                  </v-card-title>
                  <v-divider class="mx-2"></v-divider>

                  <!-- Two-column layout -->
                  <div class="two-column-menu">
                    <!-- Left column - Subcategories -->
                    <div class="subcategories-column">
                      <v-list class="modal-menu">
                        <v-list-item
                          v-for="(
                            subCategory, subIndex
                          ) in category.subCategories"
                          :key="`sub-${subIndex}`"
                          link
                          @click="handleSubcategoryClick(category, subCategory)"
                          @mouseenter="hoveredSubcategory = subCategory"
                          class="subcategory-item"
                        >
                          <v-list-item-title class="text-caption font-medium">
                            {{ subCategory.name }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </div>

                    <!-- Right column - Groups -->
                    <div class="groups-column">
                      <template v-if="hoveredSubcategory?.groups?.length">
                        <v-list class="groups-list">
                          <v-list-item
                            v-for="(
                              group, groupIndex
                            ) in hoveredSubcategory.groups"
                            :key="`group-${groupIndex}`"
                            @click="
                              handleGroupClick(
                                category,
                                hoveredSubcategory,
                                group
                              )
                            "
                            class="group-item"
                          >
                            <v-list-item-title class="text-caption">
                              {{ group.name || group.title }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </template>
                    </div>
                  </div>
                </v-card>
              </v-menu>
            </div>
          </div>
        </div>
        </div>
        </v-app-bar>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useFont } from "@/composables/useFont";
import { computed, onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useDisplay } from "vuetify";
import { useStore } from "vuex";

import NotificationsDropdown from "@/components/NotificationsDropdown.vue";
import SearchesDropdown from "@/components/SearchesDropdown.vue";
import CityService from "@/services/cities.services.js";
import CountryService from "@/services/country.services.js";
import GroupsService from "@/services/group.services.js";
import ListingService from "@/services/listing.service.js";
import AuthComponent from "./auth/authComponent.vue";

// Setup essential services
const router = useRouter();
const route = useRoute();
const store = useStore();
const display = useDisplay();
const { fontClasses } = useFont();

// State declarations
const showLoginDialog = ref(false);
const menuActive = ref(false);
const searchActive = ref(false);
const loading = ref(true);
const theFilteredListings = ref("");
const newSearchQuery = ref("");
const newSearchCategory = ref("");
const filteredItems = ref([]);
const locations = ref([]);
const listings = ref([]);
const groups = ref([]);
const country = ref(null);
const displaySavedListings = ref([]);

// Menu overlay state handling
const isAnyMenuOpen = ref(false);
const activeMenus = ref(0);

const hoveredSubcategory = ref(null);

// Filter state
const filter = ref({
  categoryId: "",
  location: "",
  purpose: "",
  bedrooms: 0,
  priceRange: 0,
  propertyType: "",
  usage: "",
  isActive: false,
});

// Menu and navigation items
const ecosystem = ref([
  {
    text: "Notifications",
    route: "/notifications",
    notify: true,
    icon: "mdi-bell-outline",
  },
  {
    text: "My Searches",
    route: "/my-searches",
    icon: "mdi-feature-search-outline",
    search: true,
  },
  {
    text: "Favorites",
    route: "/favorites",
    icon: "mdi-heart-outline",
  },
  {
    text: "Chats",
    route: "/chats",
    icon: "mdi-message-text",
    chaty: true,
  },
  {
    text: "My Ads",
    route: "/my-ads-listings", // Corrected route
    icon: "mdi-view-list-outline",
  },
]);

const bottomNav = ref([
  {
    name: "Home",
    route: "/",
    icon: "mdi-home",
  },
  {
    name: "Searches",
    route: "",
    slug: "mySearches",
    icon: "mdi-feature-search-outline",
    menu: "search",
  },
  {
    name: "Post an Ad",
    route: "",
    slug: "placeAd",
    icon: "mdi-plus-circle-outline",
  },
  {
    name: "Chats",
    route: "",
    slug: "chatMe",
    icon: "mdi-message-text",
  },
  {
    name: "menu",
    route: "",
    icon: "mdi-menu",
    menu: "menu",
  },
]);

const belowLogout = ref([
  {
    name: "Notification",
    route: "",
    slug: "notifyMe",
    icon: "mdi-bell",
  },
  {
    name: "My Ads",
    route: "",
    slug: "myAds",
    icon: "mdi-view-list-outline",
  },
]);

const dropDownItems = ref([
  {
    name: "My Recruiter Profile",
    route: "",
    slug: "myRecruiterProfile",
    icon: "mdi-view-list-outline",
  },

  {
    name: "Jobs Dashboard",
    route: "",
    slug: "jobsDashboard",
    icon: "mdi-view-list-outline",
  },

  {
    name: "Candidate Search",
    route: "",
    slug: "candidateSearch",
    icon: "mdi-view-list-outline",
  },

  {
    name: "My Ads",
    route: "",
    slug: "myAds",
    icon: "mdi-view-list-outline",
  },
  {
    name: "Chats",
    route: "",
    slug: "chatMe",
    icon: "mdi-message-text",
  },
  {
    name: "My Searches",
    route: "",
    slug: "mySearches",
    icon: "mdi-feature-search-outline",
    menu: "search",
  },
]);

const priceRanges = ref([
  { title: "Under $50", value: "0_50" },
  { title: "$50 - $100", value: "50_100" },
  { title: "$100 - $200", value: "100_200" },
  { title: "$200 - $500", value: "200_500" },
  { title: "Above $500", value: "500_10000000" },
]);

// Computed properties
const loggedInUser = computed(() => store.state.auth.user);
const user = computed(() => loggedInUser.value || {});


const categories = computed(() =>
  (store.getters['NewCategory/categories'] || []).filter(c => Number(c?.id) !== 7 && Number(c?.id) !== 8)
);


// const allCategories = computed(() => store.getters['NewCategory/categories'] || []);

// const filteredCategories = computed(() => {
//   const EXCLUDED = new Set([7, 8]);
//   return allCategories.value.filter(c => !EXCLUDED.has(Number(c?.id)));
// });

const unreadNotificationCount = computed(
  () => store.getters["notifications/unreadCount"]
);
const unreadMessageCount = computed(() => store.state.chat?.unreadCount || 0);
const displayListings = computed(
  () => store.getters["savedSearches/displayListings"]
);
const isMySearchesRoute = computed(() => route.path === "/my-searches");
const isSearchEnabled = computed(
  () =>
    filter.value.categoryId ||
    filter.value.location ||
    filter.value.purpose ||
    filter.value.bedrooms ||
    filter.value.priceRange ||
    filter.value.propertyType ||
    filter.value.usage
);

// My Ads count
const myAdsCount = computed(() => {
  return store.getters["userListings/totalListingsCount"] || 0;
});

const selectedSearchCategory = computed(() => {
  return (
    categories.value.find((cat) => cat.id === filter.value.categoryId) || {}
  );
});

// Listings grouping
const groupedListings = computed(() => {
  const searchQueryLower = ref("").value.toLowerCase();
  const filteredListings = listings.value.filter((listing) => {
    return (
      listing.title.toLowerCase().includes(searchQueryLower) ||
      listing.description.toLowerCase().includes(searchQueryLower)
    );
  });

  return filteredListings.reduce((grouped, listing) => {
    const categorySlug = listing.slug;
    if (!grouped[categorySlug]) {
      grouped[categorySlug] = [];
    }
    grouped[categorySlug].push(listing);
    return grouped;
  }, {});
});

// Methods
// Menu visibility tracking for overlay
const handleMenuVisibility = (isVisible) => {
  if (isVisible) {
    activeMenus.value++;
  } else {
    activeMenus.value = Math.max(0, activeMenus.value - 1);
  }
  isAnyMenuOpen.value = activeMenus.value > 0;
};

const getCategoryName = (slug) => {
  if (slug && categories.value) {
    const category = categories.value.find((cat) => cat.slug === slug);
    return category ? category.title : "Unknown Category";
  }
};

const convertToCurrency = (value) => {
  let number = value;

  if (typeof value === "string") {
    number = parseFloat(value.replace(/[^0-9.-]+/g, ""));
  }

  if (!isNaN(number)) {
    return "USD" + " " + number.toLocaleString("en-US");
  } else {
    return "Invalid number";
  }
};

const findCategory = (selectedCategory) => {
  const category = categories.value.find(
    (cat) => cat.slug === selectedCategory.slug
  );

  if (category) {
    store.dispatch("filter/setSelectedAttributes", category);
    store.dispatch("filter/setPropertyDialog", false);
    router.push(
      category.slug === "property"
        ? { name: "PropertiesList" }
        : {
            name: "list",
            query: {
              category: category.title,
            },
          }
    );
  } else {
    console.log("No category found");
  }
};

const selectItem = (item) => {
  store.dispatch("category/setSelectedItem", item);
  router.push("/product");
};

const filterListings = () => {
  store.dispatch("filter/setFilterAttributes", filter.value);
  router.push("/list");
};

const selectAttributes = (item) => {
  store.dispatch("filter/setSelectedAttributes", item);
};

const handleCategorySelection = (category) => {
  if (!category) {
    router.push({ name: "list" });
  } else {
    store.dispatch("filter/setSelectedAttributes", category);
    router.push(
      category.slug === "property"
        ? { name: "PropertiesList" }
        : {
            name: "list",
            query: {
              category: category.title,
            },
          }
    );
  }
};

// Enhanced Navigation Methods
const isPropertyCategory = (category) => {
  return category.id === 3 || category.id === 4;
};

const handleCategoryClick = (category) => {
  store.dispatch("FilterStore/updateFilters", { category: category });

  if (isPropertyCategory(category)) {
    router.push({
      name: "PropertySearch",
      query: {
        categoryId: category.id,
        source: "header-navigation",
      },
    });
  } else if (category.id === 2) {
    router.push({
      name: "Jobs",
    });
  } else {
    router.push({
      name: "searchResults",
      query: {
        categoryId: category.id,
        source: "header-navigation",
      },
    });
  }
};

const handleSubcategoryClick = (category, subCategory) => {
  store.dispatch("FilterStore/updateFilters", {
    category: category,
    subcategory: subCategory,
  });

  if (isPropertyCategory(category)) {
    router.push({
      name: "PropertySearch",
      query: {
        categoryId: category.id,
        subcategoryId: subCategory.id,
        source: "header-navigation",
      },
    });
  } else {
    router.push({
      name: "searchResults",
      query: {
        categoryId: category.id,
        subcategoryId: subCategory.id,
        source: "header-navigation",
      },
    });
  }
};

const handleGroupClick = (category, subCategory, group) => {
  store.dispatch("FilterStore/updateFilters", {
    category: category,
    subcategory: subCategory,
    group: group,
  });

  if (isPropertyCategory(category)) {
    router.push({
      name: "PropertySearch",
      query: {
        categoryId: category.id,
        subcategoryId: subCategory.id,
        groupId: group.id,
        source: "header-navigation",
      },
    });
  } else {
    router.push({
      name: "searchResults",
      query: {
        categoryId: category.id,
        subcategoryId: subCategory.id,
        groupId: group.id,
        source: "header-navigation",
      },
    });
  }
};

// Authentication and navigation methods
const handleLogout = () => {
  menuActive.value = false;
  store.commit("logout");
  store.dispatch("resetInactivityTimeout");
  store.dispatch("auth/logout");
  store.dispatch("resetInactivityTimeout");
  router.push("/");
  store.dispatch("alert/success", "Logout Successfully");
};

const loginOrSignup = () => {
  if (!loggedInUser.value) {
    showLoginDialog.value = true;
  }
};

// FIXED: Changed parameter name to avoid name conflict & fixed routing
const routeTo = (routePath) => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || routePath);
  }
};

const logoRoute = () => {
  router.push(route.query.redirect || "/");
};

const placeAd = () => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || "/select-your-city");
  }
};

// FIXED: Changed router.query to route.query
const notifyMe = () => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || "/notification");
  }
};

// FIXED: Changed router.query to route.query
const myChats = () => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || "/chats");
  }
};

// FIXED: Changed route path to correct my-ads-listings and fixed router.query
const myAds = () => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || "/my-ads-listings");
  }
};

const jobsDashboard = () => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || "/ats/jobs-dashboard");
  }
};

const candidateSearch = () => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || "/ats/candidate-search");
  }
};

const myRecruiterProfile = () => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || "/ats/profile");
  }
};

// FIXED: Changed router.query to route.query
const mySearches = () => {
  if (!loggedInUser.value) {
    router.push(route.query.redirect || "/auth-list");
  } else {
    router.push(route.query.redirect || "/my-searches");
  }
};

const toggle = (item) => {
  if (item.slug && item.slug === "placeAd") {
    placeAd();
    return;
  }

  if (item.slug && item.slug === "notifyMe") {
    notifyMe();
    return;
  }

  if (item.slug && item.slug === "mySearches") {
    mySearches();
    return;
  }

  if (item.slug && item.slug === "chatMe") {
    myChats();
    return;
  }

  if (item.slug && item.slug === "jobsDashboard") {
    jobsDashboard();
    return;
  }

  if (item.slug && item.slug === "candidateSearch") {
    candidateSearch();
    return;
  }

  if (item.slug && item.slug === "myRecruiterProfile") {
    myRecruiterProfile();
    return;
  }

  if (item.slug && item.slug === "myAds") {
    myAds();
    return;
  }

  if ((!item.route && item.menu === "menu") || item.menu === "search") {
    item.menu === "menu"
      ? (menuActive.value = !menuActive.value)
      : (searchActive.value = !searchActive.value);
  }
};

const isLoggedIn = () => {
  return !!localStorage.getItem("token");
};

const getInitials = (fullName) => {
  if (!fullName) return "";

  const words = fullName.trim().split(" ");
  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase();
  }

  return words[0].charAt(0).toUpperCase() + words[1].charAt(0).toUpperCase();
};

const base64ToFile = (base64String, fileType, fileName) => {
  const base64Data = base64String.replace(/^data:.+;base64,/, "");
  const byteCharacters = atob(base64Data);
  const byteArray = [...byteCharacters].map((char) => char.charCodeAt(0));
  const blob = new Blob([new Uint8Array(byteArray)], { type: fileType });
  const file = new File([blob], fileName, { type: fileType });
  return file;
};

// API Calls
const getDefaultCountry = async () => {
  try {
    const response = await CountryService.defaultCountry();
    if (response.status == 200) {
      country.value = response.data.data;
      await getcities(country.value.id);
      loading.value = false;
    } else {
      country.value = [];
      loading.value = false;
      console.log(response.data.console.error);
    }
  } catch (error) {
    country.value = [];
    if (error.response && error.response.status == 401) {
      handleLogout();
    }
    console.log(error);
    store.dispatch("alert/error", error.message);
  }
};

const getGroups = async () => {
  try {
    const response = await GroupsService.index();
    if (response.status == 200) {
      groups.value = response.data.data;
      loading.value = false;
    } else {
      groups.value = [];
      loading.value = false;
      console.log(response.data.console.error);
    }
  } catch (error) {
    loading.value = false;
    groups.value = [];
    if (error.response && error.response.status == 401) {
      handleLogout();
    }
    console.log(error);
    store.dispatch("alert/error", error.message);
  }
};

const getcities = async (countryId) => {
  try {
    const response = await CityService.getCountryCities(countryId);
    if (response.status == 200) {
      locations.value = response.data.data.slice(0, 6);
      loading.value = false;
    } else {
      locations.value = [];
      loading.value = false;
      console.log(response.data.console.error);
    }
  } catch (error) {
    locations.value = [];
    if (error.response && error.response.status == 401) {
      handleLogout();
    }
    console.log(error);
    store.dispatch("alert/error", error.message);
  }
};

const getlistings = async () => {
  try {
    const response = await ListingService.getApprovedOpenListing();
    if (response.status == 200) {
      listings.value = response.data.data;
      loading.value = false;
    } else {
      listings.value = [];
      loading.value = false;
      console.log(response.data.console.error);
    }
  } catch (error) {
    listings.value = [];
    if (error.response && error.response.status == 401) {
      handleLogout();
    }
    console.log(error);
    store.dispatch("alert/error", error.message);
  }
};

const getlistingFile = async (gridfs_id) => {
  try {
    const response = await ListingService.getListingFile(gridfs_id);
    if (response.status == 200) {
      const mimeType = response.headers["content-type"];
      const base64Image = convertToBase64(response.data, mimeType);
      loading.value = false;
      return base64Image;
    } else {
      loading.value = false;
      console.log(response.data.console.error);
      return null;
    }
  } catch (error) {
    loading.value = false;
    if (error.response && error.response.status == 401) {
      handleLogout();
    }
    console.log(error);
    return null;
  }
};

const convertToBase64 = (binaryData, mimeType) => {
  const base64String = btoa(
    new Uint8Array(binaryData).reduce(
      (data, byte) => data + String.fromCharCode(byte),
      ""
    )
  );
  return `data:${mimeType};base64,${base64String}`;
};

// Search and filter methods
const searchCategories = (query) => {
  const lowercasedQuery =
    query && typeof query === "string" ? query.toLowerCase() : "";
  const items = [];

  categories.value.forEach((category) => {
    if (
      category.title &&
      category.title.toLowerCase().includes(lowercasedQuery)
    ) {
      items.push(category.title);
      newSearchCategory.value = category;
    }

    if (category.subcategories) {
      category.subCategories.forEach((subcategory) => {
        if (
          subcategory.title &&
          subcategory.title.toLowerCase().includes(lowercasedQuery)
        ) {
          items.push(subcategory.title);
        }

        if (subcategory.groups) {
          subcategory.groups.forEach((group) => {
            if (
              group.name &&
              group.name.toLowerCase().includes(lowercasedQuery)
            ) {
              items.push(group.name);
            }
          });
        }
      });
    }
  });

  return items;
};

const searchListings = (query) => {
  const lowercasedQuery =
    query && typeof query === "string" ? query.toLowerCase() : "";
  const filteredListings = [];

  listings.value.forEach((listing) => {
    if (
      listing.title &&
      listing.title.toLowerCase().includes(lowercasedQuery)
    ) {
      filteredListings.push(listing);
    }
  });
  theFilteredListings.value = filteredListings;
  return filteredListings;
};

const filterItems = () => {
  if (newSearchQuery.value) {
    filteredItems.value = searchListings(newSearchQuery.value);
  } else {
    filteredItems.value = [];
  }
};

const handleSelect = (item) => {
  newSearchQuery.value = item;
};

const setACategory = (category) => {
  store.dispatch("filter/setSelectedAttributes", category);
};

const handleSearch = () => {
  if (theFilteredListings.value.length > 0) {
    const item = theFilteredListings.value[0];
    setACategory(item.category);
    store.dispatch("search/updateSearchCategory", item.title);
    router.push({
      name: "list",
      query: {
        category: item.category.name,
      },
    });
  }
};

// Setup watchers
watch(newSearchQuery, (newQuery) => {
  filterItems();
});

watch(displayListings, (newVal) => {
  displaySavedListings.value = newVal;

  console.log("Saved listing on watch", displaySavedListings.value);
});

watch(displayListings, (val) => {
  console.log('[Header] displayListings length:', val?.length ?? 0);
  console.log('[Header] sample:', val?.slice?.(0,2));
}, { immediate: true });

watch(() => store.getters['savedSearches/allSearches'], (val) => {
  console.log('[Header] allSearches length:', val?.length ?? 0);
  console.log('[Header] first search:', val?.[0]);
}, { immediate: true });

// Add hover delay before closing
let hoverTimer = null;

const handleSubcategoryHover = (subCategory) => {
  clearTimeout(hoverTimer);
  hoveredSubcategory.value = subCategory;
};

const handleMenuLeave = () => {
  hoverTimer = setTimeout(() => {
    hoveredSubcategory.value = null;
  }, 200); // Matches dubizzle's 200ms delay
};

// Initialize component
onMounted(async () => {
  // Fetch required data
  await getlistings();
  await getDefaultCountry();
  await getGroups();



  // Setup filter attributes
  store.dispatch("filter/setFilterAttributes", filter.value);

  // Load notifications only if user is authenticated
  if (loggedInUser.value) {
    store.dispatch("notifications/listen");
  }

  // Initialize savedSearches
  store.dispatch("savedSearches/initialize");

  // Assign display listings
  displaySavedListings.value = displayListings.value;

  console.log("Saved Listings", displaySavedListings.value);

  // ✅ FIX: Only fetch user listings if user is authenticated
  if (loggedInUser.value) {
    try {
      await store.dispatch("userListings/fetchListings");
      // User listings fetched successfully
    } catch (error) {
      console.warn("⚠️ Failed to fetch user listings:", error.message);
      // Don't throw error since it's not critical for header functionality
    }
  } else {
    // User not authenticated, skipping user listings fetch
  }
});
</script>

<style scoped>
/* Overlay styling */
.menu-overlay {
  position: fixed;
  top: 113px; /* or the height of your header */
  left: 0;
  right: 0;
  bottom: 0;

  background-color: rgba(0, 0, 0, 0.4);
  z-index: 5;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  pointer-events: none;
}

.modal-menu-card {
  border-radius: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e0e0e0;
  overflow-x: hidden !important;
}

.two-column-menu {
  display: flex;
  min-height: 300px;
  overflow: hidden !important; /* Add this to prevent any overflow */
}

.subcategories-column {
  flex: 0 0 180px;
  background: white;
  border-right: 1px solid #f0f0f0;
}

.groups-column {
  flex: 1;
  background: white;
}

.subcategory-item:hover {
  background-color: #f5f5f5 !important;
}

/* If you want to match dubizzle's exact blue */
.subcategory-item:hover .v-list-item-title {
  color: #0066cc !important; /* dubizzle's blue color */
}

/* Optional: Add slight transition to text color */
.v-list-item-title {
  transition: color 0.2s ease;
}

.category-menu-header {
  background: #fafafa;
  border-bottom: 1px solid #e0e0e0;
}

.view-all-btn {
  color: #ff0000 !important;
  text-transform: none;
  letter-spacing: normal;
}

/* Remove all decorative elements */
.subcategory-title::after,
.group-title::after {
  content: none !important;
}

/* Minimalist category headers */
.category-header .badge-hoover {
  padding: 0 8px 4px;
}

.category-header .badge-hoover::after {
  height: 1px;
  background: #000;
}

.menu-overlay.is-visible {
  opacity: 2;
  visibility: visible;
}

/* Make menus stand out above overlay */
.modal-menu-wrapper {
  z-index: 10 !important;
  position: relative;
}

/* Menu styling */
.modal-menu-card {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15) !important;
  max-height: 400px;
  overflow-y: auto;
}

.v-input__icon--append .v-icon {
  color: purple;
}

.modal-menu-wrapper {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.modal-menu {
  background-color: #ffffff !important;
  padding: 12px 0;
}

/* Two-column menu layout */
.two-column-menu {
  display: flex;
  height: 100%;
  max-height: 350px;
  gap: 0;
}

/* Left column - Subcategories */
.subcategories-column {
  flex: 1;
  border-right: 1px solid #e0e0e0;
  background-color: #ffffff;
}

.subcategories-column,
.groups-column {
  /* Create overlap between columns */
  margin-right: -1px;
  margin-left: -1px;
  overflow-y: auto; /* Keep vertical scrolling */
  overflow-x: hidden; /* Disable horizontal scrolling */
}

/* Ensure no padding breaks the hover area */
.modal-menu-card {
  padding: 0 !important;
}

/* Right column - Groups
.groups-column {
  flex: 1;
  background-color: #f5f5f5; 
  display: flex;
  flex-direction: column;
}
 */

.groups-column {
  min-width: 250px;
  background: #f5f7fa; /* Light grey background */
}

.groups-list {
  background-color: transparent !important;
  padding: 8px 0;
}

.groups-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 20px;
  text-align: center;
}

/* Subcategory styling - clean without red border */
.subcategory-item {
  transition: background-color 0.2s ease;
  border-radius: 4px;
  margin: 2px 2px;
  min-height: 32px !important; /* Reduced from default */
}

.subcategory-title {
  font-weight: 500 !important;
  color: #333 !important;
}

/* Remove hover effect completely */
.group-item:hover {
  background-color: transparent !important;
}

/* Tighten spacing between group items */
.groups-list {
  padding: 0 !important;
}

.group-item {
  min-height: 32px !important; /* Reduced from default */
  padding: 0 16px !important; /* Only horizontal padding */
  margin: 0 !important;
}

/* Remove any default Vuetify list item spacing */
.group-item::before,
.group-item::after {
  display: none !important;
}

/* Optional: Keep text color change on hover if desired */
.group-item:hover .v-list-item-title {
  color: #0066cc;
}

.group-title {
  color: #666 !important;
  font-weight: 400 !important;
}

/* Header styling */
.category-menu-header {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background-color: #fafafa;
}

.view-all-btn {
  transition: all 0.2s ease;
}

.view-all-btn:hover {
  background-color: rgba(0, 0, 0, 0.03);
  transform: translateX(2px);
}

.custom-card {
  background-color: rgba(0, 0, 0, 0.6);
}

.v-list-item-title {
  color: inherit;
}

.category-scroll-wrapper {
  display: flex;
  overflow-x: auto;
  padding-bottom: 16px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.category-scroll-wrapper::-webkit-scrollbar {
  display: none;
}

.category-scroll {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  scroll-snap-type: x mandatory;
}

.category-scroll > * {
  flex-shrink: 0;
  scroll-snap-align: start;
}

.v-col[cols="auto"] {
  margin-right: 16px;
}

.ecosystem {
  display: flex;
  align-items: center;
}

.badge-hoover:hover {
  background-color: none !important;
  background: none !important;
}

/* Override shadow styles */
.v-card,
.v-menu,
.v-btn,
.v-list,
.v-menu__content {
  box-shadow: none !important;
}

/* Avatar styles */
.v-avatar,
.ecosystem > div {
  box-shadow: none !important;
}

/* Category navigation underline hover effect */
.category-header .badge-hoover {
  position: relative;
  cursor: pointer;
  padding-bottom: 6px;
  transition: all 0.2s ease-in-out;
}

.category-header .badge-hoover::after {
  content: "";
  position: absolute;
  bottom: -6px;
  left: 0;
  width: 0;
  height: 6px;
  background-color: #000;
  transition: width 0.2s ease;
}

.category-header .badge-hoover:hover::after {
  width: 100%;
}

.category-header .badge-hoover.active::after {
  width: 100%;
  background-color: #ff0000;
}

.category-header {
  padding-bottom: 4px;
  margin-top: 4px;
}

.badge-hoover:hover {
  background: none !important;
  color: inherit;
}

.category-header .badge-hoover:hover {
  color: #000;
}
/* full-bleed bottom line that ignores inner width */
.app-bar-with-border{
  border-bottom: 0 !important;
  position: absolute !important;
  z-index: 10;
  box-shadow: none !important;
}
.app-bar-with-border::after{
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;                /* edge to edge */
  height: 1px;
  background: rgba(0,0,0,0.12);
  pointer-events: none;        /* doesn't affect overlays/menus */
}

/* center the content like a container (tweak max-width if you like) */
.bar-inner{
  width: min(1300px, 100% - 48px);  /* centered “container” */
  margin-inline: auto;
  display: flex;
  align-items: center;
 
}

/* main bar layout: spread sections across the inner width */
.bar-main{

  margin-left: 200px !important;
}

/* categories bar: keep items visually centered */
.bar-cats{
  justify-content: center;
}
.categories-row{
  display: flex;
  align-items: center;
  gap: 10px !important;
}

/* nice gap between logo and notifications */
.v-app-bar .ecosystem{ margin-left: 50px !important; }

/* keep your absolute positioning for stacking with overlay */
.v-app-bar{ position: absolute !important; }


.v-app-bar {
  position: absolute !important;
}

/* Mobile optimization */
@media (max-width: 768px) {
  .category-header .badge-hoover::after {
    height: 2px;
  }
}

@media (min-width: 1200px) and (max-width: 1700px) {
  .category-header {
    margin-left: 10px;
    font-size: 2px;
  }
}

/* Scrollbar customization */
.modal-menu-card::-webkit-scrollbar {
  width: 6px;
}

.modal-menu-card::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

/* Alternative layout for better organization */
@media (min-width: 1024px) {
  .two-column-menu {
    min-height: 300px;
  }
}

/* Responsive adjustments */
@media (max-width: 600px) {
  .two-column-menu {
    flex-direction: column;
  }

  .subcategories-column {
    border-right: none;
    border-bottom: 1px solid #e0e0e0;
  }

  .modal-menu-card {
    min-width: 300px;
  }
}

.no-bg-on-menu {
  background-color: transparent !important;
  box-shadow: none !important;
}
</style>